var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllProjectsIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.66666H9.16663",
    stroke: "#20C3FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83337 4.63317C1.83337 4.04482 1.83337 3.75064 1.87961 3.5056C2.08313 2.42688 2.92691 1.5831 4.00563 1.37957C4.25067 1.33334 4.54485 1.33334 5.13321 1.33334C5.39099 1.33334 5.51988 1.33334 5.64375 1.34492C6.17781 1.39486 6.68439 1.6047 7.09733 1.94701C7.19311 2.02641 7.28424 2.11756 7.46651 2.29984L7.83337 2.66667C8.37724 3.21052 8.64917 3.48245 8.97477 3.66362C9.15364 3.76314 9.34344 3.84174 9.54031 3.89786C9.89864 4 10.2832 4 11.0523 4H11.3014C13.0564 4 13.9338 4 14.5042 4.51298C14.5566 4.56016 14.6066 4.6101 14.6537 4.66256C15.1667 5.2329 15.1667 6.11036 15.1667 7.86527V9.33333C15.1667 11.8475 15.1667 13.1046 14.3856 13.8856C13.6046 14.6667 12.3475 14.6667 9.83337 14.6667H7.16671C4.65255 14.6667 3.39547 14.6667 2.61442 13.8856C1.83337 13.1046 1.83337 11.8475 1.83337 9.33333V4.63317Z",
    stroke: "#20C3FF",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllProjectsIcon);
export default __webpack_public_path__ + "static/media/all-projects-icon.86d3775595008abeaee1aee593734123.svg";
export { ForwardRef as ReactComponent };